import { useFadeIn } from '@/hooks/useFadeIn';
import { aboutData, contactInfo } from '@/mocks/homeData';

export default function AboutSection() {
  const { ref: sectionRef, isVisible: sectionVisible } = useFadeIn(0.1);
  const { ref: textRef, isVisible: textVisible } = useFadeIn(0.15);

  return (
    <section id="sobre" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div
            ref={sectionRef}
            className={`w-full lg:w-2/5 relative fade-section ${sectionVisible ? 'is-visible' : ''}`}
          >
            <div className="relative">
              <span className="absolute -top-4 left-4 z-10 inline-block bg-background-50 border border-background-200 text-foreground-700 text-sm font-medium px-4 py-1.5 rounded-full">
                {aboutData.cro}
              </span>
              <div className="rounded-2xl overflow-hidden img-zoom">
                <img
                  src={aboutData.image}
                  alt="Dra. Marihana Pasquali - Cirurgiã Dentista especialista em estética dental e cirurgia bucomaxilofacial em São Paulo"
                  className="w-full h-auto object-cover object-top aspect-[3/4]"
                />
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-accent-500 text-white rounded-2xl p-6 hidden lg:block">
              <p className="font-heading text-3xl font-bold">4+</p>
              <p className="text-xs text-white/80 mt-1">Anos de experiência</p>
            </div>
          </div>

          <div
            ref={textRef}
            className={`w-full lg:w-3/5 fade-section ${textVisible ? 'is-visible' : ''}`}
            style={{ transitionDelay: '150ms' }}
          >
            <span className="text-xs uppercase tracking-[0.2em] text-primary-500 font-semibold mb-3 block">
              Sobre a profissional
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              Dra. Marihana Pasquali
            </h2>
            <p className="text-foreground-500 text-sm font-medium mb-6">
              Cirurgiã Dentista — Especializanda em Cirurgia Bucomaxilofacial e Estética Dental
            </p>

            <p className="text-foreground-600 text-base leading-relaxed mb-4">
              {aboutData.description}
            </p>
            <p className="text-foreground-600 text-base leading-relaxed mb-6">
              {aboutData.extendedBio}
            </p>

            <blockquote className="border-l-2 border-accent-400 pl-5 italic text-foreground-500 text-sm mb-8">
              "{aboutData.philosophy}"
            </blockquote>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-8">
              {aboutData.stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1 leading-tight">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>

            {/* Fotos da Dra. em cirurgia no hospital */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="rounded-xl overflow-hidden aspect-[4/5] img-zoom">
                <img
                  src="https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/d11e1388-aa1d-43dd-b050-90b06fa6d47b_compressed_IMG_2808.webp"
                  alt="Dra. Marihana Pasquali em cirurgia no Hospital Santa Paula"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[4/5] img-zoom">
                <img
                  src="https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/b889e5f3-3a45-4315-b768-dfbdf4563149_compressed_512F1417-5DD8-46A3-9372-DAC6D2CCBD10.JPG---Copia---Copia-2.webp"
                  alt="Dra. Marihana Pasquali no centro cirúrgico"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-xl overflow-hidden aspect-[4/5] img-zoom">
                <img
                  src="https://storage.readdy-site.link/project_files/d597c584-8282-4ae1-8b44-377681ee7a13/c84d9267-a03b-4e95-ad9b-6032112059bd_compressed_IMG_3374.webp"
                  alt="Dra. Marihana Pasquali durante procedimento cirúrgico"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <a
              href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Dra.%20Marihana.`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-foreground-950 text-background-50 text-sm font-semibold px-8 py-3.5 rounded-full hover:bg-foreground-800 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              Agendar uma Consulta
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}